// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___2EfDR","popover":"styles__popover___xpWZL","text":"styles__text___3u2EA","option":"styles__option___3eUYw"};